import { PropTypes, React } from 'imports';
import { FormattedResource, Tooltip } from 'components/common';
import { stripURI } from 'utils';
import { injectIntl, intlShape } from 'react-intl';
import marked from 'marked';
import './MarkdownBlock.less';

const
    URI_PATTERN = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm,
    MARKDOWN_LINK_PATTERN = /^\[.*?\]\(.*?\)$/i,

    renderer = new marked.Renderer();

renderer.link = function(href, title, text) {
    if (text === href || !text) {
        text = stripURI(text || href);
    }

    return marked.Renderer.prototype.link.call(this, href, title, text).replace(/^<a/, '<a target="_blank"');
};

marked.setOptions({
    breaks: true,
    gfm: true,
    renderer
});

class MarkdownBlock extends React.PureComponent {
    static getPropTypes() {
        return {
            intl: intlShape.isRequired,

            value: FormattedResource.resourcePropType.isRequired,
            inline: PropTypes.bool,
            className: PropTypes.string
        };
    }

    static get defaultProps() {
        return {
            className: ''
        };
    }

    shouldComponentUpdate(nextProps) {
        return this.props.value !== nextProps.value;
    }

    _formatLinks(str) {
        const uriMatches = str.match(URI_PATTERN);

        let charIndex = 0;
        const formattedStringArray = [];

        if (uriMatches) {
            for (let matchIndex = 0; matchIndex < uriMatches.length; matchIndex++) {
                const
                    uriMatch = uriMatches[matchIndex],
                    matchStartIndex = str.indexOf(uriMatch, charIndex),

                    strWithMatchTail = str.substring(0, matchStartIndex + uriMatch.length + 1),
                    possibleMarkdownLinkStartIndex = strWithMatchTail.lastIndexOf('['),
                    possibleMarkdownLink = possibleMarkdownLinkStartIndex >= 0 ? strWithMatchTail.substring(possibleMarkdownLinkStartIndex) : '',

                    isProperMarkdownLink = MARKDOWN_LINK_PATTERN.test(possibleMarkdownLink);

                formattedStringArray.push(str.slice(charIndex, matchStartIndex), isProperMarkdownLink ? uriMatch : `[${uriMatch}](${uriMatch})`);

                charIndex = matchStartIndex + uriMatch.length;
            }
        }

        return [...formattedStringArray, str.slice(charIndex)].join('');
    }

    static get MarkdownBlockHint() {
        return (
            <div className="markdown-block-hint">
                <span className="hint-button">
                    *<i className="fa fa-font" />
                    <Tooltip className="text-formatting-hint" direction={Tooltip.Direction.BOTTOM} showTimeout={0} hideTimeout={300}>
                        <h4><FormattedResource resource={{ id: 'newsfeed.text_formatting' }} /></h4>
                        <FormattedResource resource={{ id: 'newsfeed.you_can_format_your_text_in_following_way' }} />:<br /><br />
                        <code>**<FormattedResource resource={{ id: 'common.bold' }} />**</code> = <strong><FormattedResource resource={{ id: 'common.bold' }} /></strong><br />
                        <code># <FormattedResource resource={{ id: 'common.heading' }} /></code> = <strong><FormattedResource resource={{ id: 'common.heading' }} /></strong><br /><br />
                        <FormattedResource resource={{ id: 'common.list' }} />:<br />
                        <code>
                            - <FormattedResource resource={{ id: 'common.item' }} /> 1<br />
                            - <FormattedResource resource={{ id: 'common.item' }} /> 2<br />
                            &nbsp;- <FormattedResource resource={{ id: 'common.item' }} /> 2.1<br />
                        </code>
                        <br />
                        <ul>
                            <li><FormattedResource resource={{ id: 'common.item' }} /> 1</li>
                            <li>
                                <FormattedResource resource={{ id: 'common.item' }} /> 2
                                <ul>
                                    <li><FormattedResource resource={{ id: 'common.item' }} /> 2.1</li>
                                </ul>
                            </li>
                        </ul>
                    </Tooltip>
                </span>&nbsp;
                <FormattedResource resource={{ id: 'common.formatting' }} />
            </div>
        );
    }

    render() {
        const
            value =
                typeof this.props.value === 'string' ? this.props.value :
                    typeof this.props.value === 'object' && this.props.value && this.props.value.id ? this.props.intl.formatMessage(this.props.value, this.props.value.values) :
                        '',

            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        return <div className={`markdown-block ${this.props.inline ? 'inline ' : ''} ${!isSafari ? 'with-list-fix' : ''} ${this.props.className}`}
            dangerouslySetInnerHTML={{ __html: marked(this._formatLinks(value)) }} />;
    }
}

export default injectIntl(MarkdownBlock);
